import type { DrillParameters } from '@acepoker/contract'

export enum MovesQuality {
  correct = 'Correct actions',
  best = 'Best actions',
  blunder = 'Blunders',
  inaccuracy = 'Inaccuracies',
  wrong = 'Wrong actions',
  unknown = 'Unknown'
}

export interface Hand {
  moveId: string
  playerCards: string
  communityCards: string
  quality: keyof typeof MovesQuality
  ev: number
  strategy: number
}

export interface Session {
  sessionId: string
  correctMovePercent: number
  currentHands: Hand[]
}

export interface Statistics {
  avgEVLoss: number
  handsTotal: number
  maxHandsPerSession: number
  totalEVLoss: number
}

export interface Move {
  count: number
  quality: keyof typeof MovesQuality
}

export interface DealItemProps {
  id: string
  type: 'deal'
  stage: 'Flop' | 'Turn' | 'River'
  cards: string
}

export interface MoveItemProps {
  id: string
  type: 'move'
  move: 'Fold' | 'Call' | 'Raise' | 'Check' | 'Bet'
  value: number
  position: string
  quality?: keyof typeof MovesQuality
  highlighted?: boolean
}

export type StatisticType = 'session' | 'total'

export interface PracticeItemProps {
  id: string
  currency?: string
  name: string
  gaming_configuration: {
    antes: number
    blinds: number[]
    game: string
  }
  learning_mode?: boolean
  max_players: number
  starting_stack?: number
  rebuy_configuration?: {
    buyout_amount: number
    buyout_trigger: number
    rebuy_amount: number
    rebuy_trigger: number
  }
  hint?: string
  rankIcon?: string
  hands?: number
  score?: number
  rate?: number
}

export enum DrillManageActionType {
  edit = 'edit',
  share = 'share',
  resetStats = 'reset-stats',
  duplicate = 'duplicate',
  delete = 'delete'
}

export type AnalysisModeEvents = {
  app: string
} & (
  | {
      type: 'appSize'
      payload: {
        width: number
        height: number
        widowWidth: number
        windowHeight: number
      }
    }
  | {
      type: 'openLink'
      payload: {
        link: string
        target?: string
      }
    }
  | {
      type: 'createDrill'
      payload: {
        config: DrillParameters
      }
    }
  | {
      type: 'fullscreenMode'
      payload: {
        flags: UiHideFlags
      }
    }
  | {
      type: 'closePopup'
      payload: {
        openEmailSavePopup: boolean
      }
    }
)

export type SeatConfig = {
  top: number
  left: number
  mode: 'left' | 'right'
  popupPlacement: 'top' | 'bottom' | 'left' | 'right'
}

export enum UiHideFlags {
  showAll = 0,
  hideHeader = 1 << 0,
  hideBottomNav = 1 << 1,
  hideBottomNavMobile = 1 << 1,
  hideBottomNavDesktop = 1 << 2,
  hideAll = hideHeader | hideBottomNavMobile | hideBottomNavDesktop,
  ReplaceLogoWithBack = 1 << 3
}

export interface PlayerIdentifier {
  playerId: string
  playerEmail?: string
}

export type DevicePlatform = 'desktop' | 'mobile'
